import { useEffect, useState } from 'react'

import { SearchIcon } from 'components/icons/Search.icon'
import { CrossIcon } from 'components/svgs/Cross.svg'
import { useDebounce } from 'hooks/useDebounce'

import styles from './SearchBar.module.scss'

export interface SearchBarProps {
  onSearchChange?: (search: string) => void
  className?: string
  onDebouncedSearch?: (search: string) => void
  placeholder?: string
}

export const SearchBar = (props: SearchBarProps) => {
  const { onSearchChange, className, onDebouncedSearch, placeholder } = props
  const [searchValue, setSearchValue] = useState('')

  const debouncedSearch = useDebounce(searchValue, 200)

  const handleSearchChange = (event: any) => {
    const value = event.currentTarget.value
    setSearchValue(value)
    onSearchChange && onSearchChange(value)
  }

  useEffect(() => {
    onSearchChange && onSearchChange(searchValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue])

  useEffect(() => {
    onDebouncedSearch && onDebouncedSearch(debouncedSearch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch])

  return (
    <div className={`relative flex flex-1 ${className}`}>
      <input
        type="search"
        placeholder={placeholder || 'Search by name, category, or keyword'}
        className={`${styles.search} w-full px-10 py-2 rounded-lg border border-[#9B9B9B] focus:outline-none bg-transparent text-[14px]`}
        onChange={handleSearchChange}
        value={searchValue}
      />
      <SearchIcon className="absolute top-1/2 left-3 transform -translate-y-1/2 text-[#505050]" />
      {searchValue && (
        <button className="absolute top-1/2 right-5 transform -translate-y-1/2" onClick={() => setSearchValue('')}>
          <CrossIcon />
        </button>
      )}
    </div>
  )
}
